var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-icon",class:[ _vm.size ? `loading-${_vm.size}` : '' ]})
}
var staticRenderFns = []

export { render, staticRenderFns }